import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    pathname: '',
    error: null,
};
const { reducer, actions } = createSlice({
    name: 'router',
    initialState,
    reducers: {
        setPathname: (state, { payload }) => {
            state.pathname = payload;
        },
    },
});
export const { setPathname } = actions;
export default reducer;
